// extracted by mini-css-extract-plugin
export default {"button":"NotificationToast_button__S3dmY"};